import React, {
    useState
} from 'react';

import { 
   IonPage,
   IonHeader,
   IonContent,
   IonToolbar,
   IonTitle,
   IonGrid,
   IonRow,
   IonCol,
   IonButtons,
   IonButton,
   IonBackButton,
   NavContext,
   IonCard,
   IonCardHeader,
   IonCardSubtitle,
   IonCardTitle,
   IonCardContent,
   IonImg,
   IonIcon,
   IonText,
   IonItem,
   useIonViewWillEnter,
   useIonRouter
} from '@ionic/react';
import { RouteComponentProps } from "react-router-dom";

import { cube, person, cash, paperPlane, wallet, caretForward } from "ionicons/icons";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import { LANGUAGE, GetStr } from "../language/Language";

interface WithdrawSusProp extends RouteComponentProps<{
    address : string,
    amount : string
    }> 
{} 

const WithdrawSuccess : React.FC<WithdrawSusProp> = ({match}) => {

    //	Initializing our router
	const router = useIonRouter();

    const success = () => {
        router.push("/token/wallet", "back", "pop");
    }

    return (
        <IonPage>
            <IonContent>
                <div id="border-bk" />
                <IonGrid className="ion-no-padding full-content">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol size-md="8" size-lg="6" size-xl="4" size="12">
                            <div className="ion-text-center ion-padding">
                                <IonText><h4>{ GetStr(LANGUAGE.TXT_WIDTHDRAW_SUS) }</h4></IonText>
                            </div>
                            <IonImg className="icon-pic" src="/assets/img/fly_pic.png" />

                            <IonCard className="flat-card">
                                <IonCardContent>
                                    <div>{ GetStr(LANGUAGE.TXT_WIDTHDRAW_ADDRESS) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={person} slot="start"></IonIcon>
                                        {match.params.address}
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_WIDTHDRAW_AMT) }</div>
                                    <IonItem lines="none">
                                        <IonIcon icon={cash} slot="start"></IonIcon>
                                        <b>$ {match.params.amount}</b>
                                    </IonItem>
                                    <div>{ GetStr(LANGUAGE.TXT_WIDTHDRAW_TIME) }</div>
                                    <br/>
                                    <IonButton className="main-but ion-margin-top" color="primary" expand="block" onClick={success} >{ GetStr(LANGUAGE.TXT_WIDTHDRAW_BACK) }</IonButton>
                                </IonCardContent>
                            </IonCard>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonContent>
        </IonPage>
    );
}

export default WithdrawSuccess;